import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import addUserService from "../Services/addUser";
import UserService from "../Services/UserList";
import { handleApiError } from "../Helpers/handleApiError ";
import { handleApiSuccess } from "../Helpers/handleApiSuccess ";
import Homepage from "./Homepage1";
import MainLayout from "./admin/MainLayout";
import Lottie from "lottie-react";
import { Navigate, useNavigate } from "react-router-dom";
import animationData from "../animations/loader_animation0.json";
import { fetchRegion, fetchState, fetchUserOption } from "../redux/slices/clientSlice";
import { useDispatch, useSelector } from "react-redux";
export default function FormAddUser() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { stateData, regionData, userOption } = useSelector((state) => state.client);

  const [formData, setFormData] = useState({
    user_type: "Company",
    name: "",
    last_name: "",
    email: "",
    phone: null,
    city: "",
    state: "",
    emp_code: "",
    designation: "",
    role: "",
    salesEnablers: "",
    channel: "",
  });

  const [channels, setChannels] = useState([]);

  useEffect(() => {
    dispatch(fetchRegion());
    dispatch(fetchUserOption());

    const fetchChannelsList = async () => {
      try {
        const response = await UserService.GetChannels();
        if (response && response.status && response.data) {
          setChannels(response.data);
        }
      } catch (error) {
        console.error("Error fetching channels:", error);
      }
    };
    fetchChannelsList();
  }, []);

  useEffect(() => {
    dispatch(fetchState({ id: regionData?.find(r => r.name === formData.city)?.id }));
  }, [formData.city]);

  const [loading, setLoading] = useState(false);
  const [filteredDesignations, setFilteredDesignations] = useState([]);
  const [users, setUsers] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.user_type === "Company") {
      if (!formData.name || !formData.email || !formData.emp_code || !formData.city || !formData.state || !formData.role) {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          text: "Please fill all required fields for Employee",
          timer: 3000,
        });
        return;
      }
    } else if (formData.user_type === "Dealer") {
      if (!formData.name || !formData.email || !formData.emp_code || !formData.city || !formData.state) {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          text: "Please fill all required fields for Dealer",
          timer: 3000,
        });
        return;
      }
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Email",
        text: "Please enter a valid email address",
        timer: 3000,
      });
      return;
    }

    try {
      setLoading(true);
      const response = await addUserService.addUser(formData);
      console.log(response);
      if (response.status) {
        handleApiSuccess(response.message, "Success");
        setLoading(false);
        navigate("/admin/userlist");
      } else {
        setLoading(false);
        handleApiError(
          response,
          "Failed to fetch data. Please try again later."
        );
      }
    } catch (error) {
      console.log(error);
      handleApiError(error, "Failed to fetch data. Please try again later.");
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "warning",
        text: error,
        timer: 3000,
      });
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let nextState = { ...prev, [name]: value };

      if (name === 'user_type') {
        nextState.role = value === "Dealer" ? "7" : "";
        nextState.designation = "";
        nextState.salesEnablers = "";
      }

      if (name === 'role') {
        nextState.designation = "";
        nextState.salesEnablers = "";
      }

      return nextState;
    });
  };

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const response = await UserService.UserList();
        setUsers(response.data.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserList();
  }, []);

  useEffect(() => {
    let userOptions;
    if (formData.role == 3) {
      userOptions = userOption?.filter((item) => item.role_id == 2)?.sort((a, b) => a.name.localeCompare(b.name));
    }
    else if (formData.role == 4) {
      userOptions = userOption?.filter((item) => item.role_id == 2)?.sort((a, b) => a.name.localeCompare(b.name));
    }
    setFilteredDesignations(userOptions);
  }, [formData.role]);

  const salesEnablerOpt = userOption?.filter((item) => item.role_id == 6);

  return (
    <MainLayout>
      {loading ? (
        <div className="flex items-center justify-center min-h-[60vh]">
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ height: "150px", width: "150px" }}
          />
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="bg-gradient-to-br  from-blue-50 via-white to-indigo-50 p-8 rounded-2xl shadow-xl max-w-4xl mx-auto   border border-opacity-20 border-indigo-300 transform transition-all hover:shadow-2xl"
        >
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-800 bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              Employee Details
            </h2>
            <p className="text-gray-500 mt-2">Please fill the information</p>
          </div>

          {/* Form Fields */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

            <div className="space-y-1">
              <label
                htmlFor="user_type"
                className="block text-sm font-medium text-gray-600"
              >
                User Type *
              </label>
              <div className="relative group">
                <select
                  id="user_type"
                  name="user_type"
                  value={formData.user_type}
                  onChange={handleChange}
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                >
                  <option value="Company">Company</option>
                  <option value="Dealer">Dealer</option>
                </select>
              </div>
            </div>

            {/* First Name */}
            <div className="space-y-1">
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-600"
              >
                First Name *
              </label>
              <div className="relative group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter First Name"
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                />
              </div>
            </div>

            {/* Last Name */}
            <div className="space-y-1">
              <label
                htmlFor="last_name"
                className="block text-sm font-medium text-gray-600"
              >
                Last Name *
              </label>
              <div className="relative group">
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Enter Last Name"
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                />
              </div>
            </div>

            {/* Email */}
            <div className="space-y-1">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-600"
              >
                Email Address *
              </label>
              <div className="relative group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@domain.com"
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                />
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="space-y-1">
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-600"
              >
                Phone
              </label>
              <div className="relative group">
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="1234567890"
                  maxLength={10}
                  pattern="[0-9]{10}"
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                />
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
              </div>
            </div>


            {/* Code */}

            <div className="space-y-1">
              <label
                htmlFor="emp_code"
                className="block text-sm font-medium text-gray-600"
              >
                {formData?.user_type === "Company" ? "Employee Code *" : "GST No.*"}
              </label>
              <div className="relative group">
                <input
                  type="text"
                  id="emp_code"
                  name="emp_code"
                  value={formData.emp_code}
                  onChange={handleChange}
                  placeholder={formData.user_type === 'Dealer' ? "Enter GST No." : "Enter Employee Code"}
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                />

                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                  </svg>
                </div>
              </div>
            </div>

            {/* City */}
            <div className="space-y-1">
              <label
                htmlFor="city"
                className="block text-sm font-medium text-gray-600"
              >
                Region *
              </label>
              <div className="relative group">
                <select
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                >
                  <option value="">Select Region</option>
                  {regionData?.map(region => (
                    <option key={region.id} value={region.name}>
                      {region.name}
                    </option>
                  ))}
                </select>
                {/* <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div> */}
              </div>
            </div>

            {/* State */}
            <div className="space-y-1">
              <label
                htmlFor="state"
                className="block text-sm font-medium text-gray-600"
              >
                State *
              </label>
              <div className="relative group">
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                >
                  <option value="">Select State</option>
                  {stateData?.map(s => (
                    <option key={s.id} value={s.name}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="space-y-1">
                <label
                  htmlFor="channel"
                  className="block text-sm font-medium text-gray-600"
                >
                  Channel Name
                </label>
                <div className="relative group">
                  <select
                    id="channel"
                    name="channel"
                    value={formData.channel || ""}
                    onChange={handleChange}
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  >
                    <option value="">Select Channel</option>
                    {channels?.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.channel_name}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>

            {formData?.user_type == 'Company' &&
              <div className="space-y-1">
                <label
                  htmlFor="Role"
                  className="block text-sm font-medium text-gray-600"
                >
                  Role *
                </label>
                <div className="relative group">
                  <select
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  >
                    <option value="">Select Role</option>
                    <option value="2">IC</option>
                    <option value="3">BSP</option>
                    <option value="4">DSP</option>
                    <option value="5">BD</option>
                    <option value="6">Sales Enabler</option>
                    <option value="8">Studio</option>
                  </select>

                  <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            }
            {(formData.role == 3 || formData.role == 4) &&
              <div className="space-y-1">
                <label
                  htmlFor="state"
                  className="block text-sm font-medium text-gray-600"
                >
                  IC
                </label>
                <div className="relative group">
                  <select
                    id="designation"
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  >
                    <option value="">Select IC</option>
                    {filteredDesignations?.map((designation) => (
                      <option key={designation.id} value={designation.id}>
                        {`${designation.name} ${designation.last_name ? designation.last_name : ''} - ${designation.emp_code}`}
                      </option>
                    ))}
                  </select>

                  <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            }
            {(formData.role == 2) &&
              <div className="space-y-1">
                <label
                  htmlFor="state"
                  className="block text-sm font-medium text-gray-600"
                >
                  Sales Enabler
                </label>
                <div className="relative group">
                  <select
                    id="salesEnablers"
                    name="salesEnablers"
                    value={formData.salesEnablers}
                    onChange={handleChange}
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  >
                    <option value="">Select Sales Enabler</option>
                    {salesEnablerOpt?.map((s) => (
                      <option key={s.id} value={s.id}>
                        {`${s.name} ${s.last_name ? s.last_name : ''} - ${s.emp_code}`}
                      </option>
                    ))}
                  </select>

                  <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            }
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-6 pt-6">
            <button
              type="submit"
              className="relative overflow-hidden bg-gradient-to-r from-yellow-500 to-yellow-500 text-white px-8 py-3 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:ring-offset-2 transition-all duration-300 group"
            >
              <span className="relative z-10 font-medium">Save Details</span>
              <span className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
            </button>
          </div>
        </form>
      )}
    </MainLayout>
  );
}
